<template>
  <v-form ref="cashiersForm">
    <v-row>
      <v-col md="4">
        <p class="font-weight-black text-h6">Titular y miembros</p>
        <v-card>
          <v-card-title class="">
            <v-row>
              <v-col md="2">
                <v-avatar size="56">
                  <img alt="user" src="../../../assets/img/iconUser.png" />
                </v-avatar>
              </v-col>
              <v-col md="10">
                <p class="ml-3 text-h6">{{ Titular.text }}</p>
                <p class="text-subtitle-1 ml-3 mt-n3 grey--text">Titular</p>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-list two-line>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo"> mdi-star-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{
                    PlanMembresia ? PlanMembresia.Nomb : "Sin Plan"
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Plan de membresia</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo"> mdi-email </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ Titular.Correo }}</v-list-item-title>
                  <v-list-item-subtitle>E-mail</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
        <v-card class="mt-4">
          <v-card-title>Miembros</v-card-title>
          <v-list two-line>
            <v-list-item
              v-for="(cliente, index) in Membresia.Clientes"
              :key="index"
            >
              <v-list-item-icon>
                <v-icon color="indigo"> mdi-account-multiple </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  getDataCliente(index)
                    ? getDataCliente(index).getNombreCompleto()
                    : "Sin Cliente"
                }}</v-list-item-title>
                <v-list-item-subtitle>Miembro</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col md="8">
        <p class="font-weight-black text-h6">Detalles de membresia</p>
        <v-row>
          <v-col md="12">
            <v-card>
              <v-tabs>
                <v-tab>Detalle Pagos</v-tab>
                <v-tab>Beneficios</v-tab>
                <v-tab-item>
                  <div class="ma-4">
                    <v-alert
                      v-if="Membresia.Deuda && Membresia.Deuda.C > 0"
                      dense
                      outlined
                      type="error"
                    >
                      La membresia presenta un adeudo de
                      <strong
                        >${{
                          this.$pgsHelper.formatNumber(Membresia.Deuda.C)
                        }}</strong
                      >
                      {{ Membresia.Deuda.M }}
                    </v-alert>
                    <v-alert
                      v-if="!Membresia.Deuda || Membresia.Deuda.C == 0"
                      dense
                      outlined
                      type="success"
                    >
                      La membresia esta al dia con sus pagos
                    </v-alert>
                    <v-alert
                      v-if="!Membresia.Deuda || Membresia.Deuda.C < 0"
                      dense
                      outlined
                      type="success"
                    >
                      La membresia tiene un saldo a favor de
                      <strong>{{
                        this.$pgsHelper.formatNumber(Membresia.Deuda.C * -1)
                      }}</strong>
                      {{ Membresia.Deuda.M }}
                    </v-alert>
                    <v-row>
                      <v-col md="12">
                        <MovimientosCRUD :membresia_id="Membresia.Id">
                        </MovimientosCRUD>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card class="mx-auto my-2" max-width="400" v-if="false">
                    <v-card-text>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-title class="text-h5">
                            ${{ $pgsHelper.formatNumber(4800) }}
                          </v-list-item-title>
                          <v-list-item-subtitle>Adeudo</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card-text>
                    <v-card-text>
                      <v-list class="transparent">
                        <v-list-item>
                          <v-list-item-title>Pago Minimo</v-list-item-title>
                          <v-list-item-subtitle class="text-right">
                            ${{ $pgsHelper.formatNumber(3000) }}
                          </v-list-item-subtitle>
                        </v-list-item>
                      </v-list>
                      <v-list class="transparent">
                        <v-list-item>
                          <v-list-item-title
                            >Pago Minimo + intereses</v-list-item-title
                          >
                          <v-list-item-subtitle class="text-right">
                            ${{ $pgsHelper.formatNumber(4000) }}
                          </v-list-item-subtitle>
                        </v-list-item>
                      </v-list>
                      <v-list class="transparent">
                        <v-list-item>
                          <v-list-item-title
                            >Pago para no generar intereses</v-list-item-title
                          >
                          <v-list-item-subtitle class="text-right">
                            ${{ $pgsHelper.formatNumber(5000) }}
                          </v-list-item-subtitle>
                        </v-list-item>
                      </v-list>
                      <v-list class="transparent">
                        <v-list-item>
                          <v-list-item-title
                            >Pago para liquidar</v-list-item-title
                          >
                          <v-list-item-subtitle class="text-right">
                            ${{ $pgsHelper.formatNumber(5000) }}
                          </v-list-item-subtitle>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat v-if="Membresia.Contadores">
                    <v-card-text><h4>Beneficios por miembro</h4></v-card-text>
                    <template v-for="(cliente, index) in Membresia.Clientes">
                      <v-card class="ma-2" :key="index" elevation="2">
                        <v-card-title>
                          <h5>
                            {{
                              getDataCliente(index)
                                ? getDataCliente(index).getNombreCompleto()
                                : "Sin Cliente"
                            }}
                          </h5>
                        </v-card-title>
                        <v-simple-table>
                          <thead>
                            <tr>
                              <th class="text-left">Beneficio</th>
                              <th class="text-left">Incluido en el plan</th>
                              <th class="text-left">Usado</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(
                                beneficio, indexBeneficio
                              ) in Beneficios.Beneficios"
                              :key="indexBeneficio"
                            >
                              <td>{{ beneficio.Desc }}</td>
                              <td>
                                {{
                                  beneficio.Cantidad
                                    ? beneficio.Cantidad
                                    : "Ilimitado"
                                }}
                              </td>
                              <td>
                                {{
                                  Membresia.Contadores[cliente]
                                    ? Membresia.Contadores[cliente][
                                        beneficio.IDX
                                      ]
                                      ? Membresia.Contadores[cliente][
                                          beneficio.IDX
                                        ].U
                                      : "0"
                                    : 0
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-card>
                    </template>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<style scoped>
.amountContainer {
  margin-top: -30px !important;
}
</style>

<script>
import MembresiaClass from "../../../clases/Membresias/Membresia.js";
import Cliente from "../../../clases/Cliente.js";
import MovimientosCRUD from "../Movimientos/MovimientosCRUD.vue";
export default {
  name: "DetalleMembresia",
  components: { MovimientosCRUD },
  props: ["edit", "dataEdit"],
  data() {
    return {
      PlanMembresia: null,
      Beneficios: {},
      Titular: "",
    };
  },
  methods: {
    getDataCliente(id) {
      let data = {};
      data = Cliente.getById(id);
      return data;
    },
  },
  computed: {
    comp_clients() {
      let clientes = [];
      let rowclientes = this.$store.getters.getClientes;
      rowclientes.forEach((element) => {
        if (element.id != "PUBLICOGENERAL") {
          clientes.push(element);
        }
      });
      clientes.forEach((cli) => {
        cli.value = cli.id;
        cli.text = cli.Apellidos + " " + cli.Nombres;
      });
      return clientes;
    },
    Membresia() {
      let membresia = MembresiaClass.getById(this.$route.params.idMembresia);
      return membresia;
    },
  },
  beforeMount: async function () {},
  async mounted() {
    if (this.Membresia) {
      this.PlanMembresia = await this.Membresia.getPlan();
      this.Beneficios = await this.PlanMembresia.getBeneficios();
      this.Titular = this.$pgsHelper.getById(
        this.comp_clients,
        "id",
        this.Membresia.Titular
      );
      this.Titular.NombreCompleto =
        this.Titular.text +
        (this.Titular.Apodo && this.Titular.Apodo != ""
          ? " (" + this.Titular.Apodo + ")"
          : "");
    }
  },
};
</script>
